import { createFileRoute } from '@tanstack/react-router'

import { QuizDetailPage } from '@/features/quizzes'
import { buildPageTitle } from '@/shared/lib/page-title'

export const Route = createFileRoute('/_authenticated/_main/quizzes/$quizId')({
  head: () => ({
    meta: [{ title: buildPageTitle('Quiz') }]
  }),
  component: QuizDetailRoute
})

function QuizDetailRoute() {
  const { quizId } = Route.useParams()

  return <QuizDetailPage quizId={Number(quizId)} />
}
